import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import background from "./images/background.png";

const API = process.env.REACT_APP_API_URL || "";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    setError("");
    if (!password || !confirm) {
      setError("Completa los dos campos bb");
      return;
    }
    if (password.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres");
      return;
    }
    if (password !== confirm) {
      setError("Las contraseñas no coinciden");
      return;
    }
    if (!token) {
      setError("Link inválido");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API}/api/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || "Algo salió mal");
        return;
      }
      setSuccess(true);
    } catch {
      setError("Error de conexión, intenta de nuevo");
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    background: "white",
    border: "1.5px solid #e0d0f0",
    borderRadius: "16px",
    padding: "12px 14px",
    fontSize: "14px",
    fontFamily: "Quicksand, sans-serif",
    outline: "none",
    width: "100%",
    color: "#2d1f3d",
  };

  const labelStyle = {
    fontSize: "11px",
    fontWeight: 700,
    color: "#b06ab3",
    marginBottom: "4px",
  };

  return (
    <div
      className="flex flex-col font-quicksand"
      style={{
        backgroundImage: `url(${background})`,
        backgroundRepeat: "repeat-y",
        backgroundSize: "100% auto",
        backgroundPosition: "top center",
        minHeight: "calc(100vh - 120px)",
      }}
    >
      <div className="px-5 pt-6 pb-10 flex flex-col gap-5">
        {/* Header */}
        <div>
          <p
            style={{
              fontSize: "10px",
              fontWeight: 700,
              letterSpacing: "0.1em",
              color: "#b06ab3",
              textTransform: "uppercase",
              marginBottom: "4px",
            }}
          >
            Nueva contraseña
          </p>
          <h1
            style={{
              fontSize: "22px",
              fontWeight: 800,
              color: "#2d1f3d",
              lineHeight: 1.2,
            }}
          >
            {success ? "¡Listo bb! 🎉" : "Elige tu nueva contraseña 🔑"}
          </h1>
        </div>

        <div
          style={{
            background: "rgba(255,255,255,0.92)",
            borderRadius: "28px",
            padding: "24px 20px",
            boxShadow: "0 4px 24px rgba(176,106,179,0.1)",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          {!token ? (
            <div style={{ textAlign: "center", display: "flex", flexDirection: "column", gap: "12px" }}>
              <span style={{ fontSize: "36px" }}>😕</span>
              <p style={{ fontSize: "13px", color: "#9b7eaa", margin: 0 }}>
                Este link no es válido. Solicita uno nuevo desde la pantalla de login.
              </p>
            </div>
          ) : success ? (
            <div style={{ textAlign: "center", display: "flex", flexDirection: "column", gap: "12px" }}>
              <span style={{ fontSize: "36px" }}>💙</span>
              <p style={{ fontSize: "14px", fontWeight: 700, color: "#2d1f3d", margin: 0 }}>
                Contraseña cambiada con éxito
              </p>
              <p style={{ fontSize: "12px", color: "#9b7eaa", margin: 0 }}>
                Ya puedes iniciar sesión con tu nueva contraseña.
              </p>
              <button
                onClick={() => navigate("/login")}
                style={{
                  background: "#7BDCFB",
                  border: "none",
                  borderRadius: "999px",
                  padding: "14px",
                  fontSize: "15px",
                  fontWeight: 700,
                  color: "white",
                  fontFamily: "Quicksand, sans-serif",
                  cursor: "pointer",
                }}
              >
                Iniciar sesión
              </button>
            </div>
          ) : (
            <>
              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <label style={labelStyle}>Nueva contraseña</label>
                <input
                  type="password"
                  placeholder="mínimo 6 caracteres"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={inputStyle}
                />
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <label style={labelStyle}>Confirmar contraseña</label>
                <input
                  type="password"
                  placeholder="repite tu contraseña"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  style={inputStyle}
                />
              </div>

              {error && (
                <p style={{ fontSize: "12px", color: "#f87171", margin: 0 }}>
                  {error}
                </p>
              )}

              <button
                onClick={handleSubmit}
                disabled={loading}
                style={{
                  background: loading ? "#b0e8fb" : "#7BDCFB",
                  border: "none",
                  borderRadius: "999px",
                  padding: "14px",
                  fontSize: "15px",
                  fontWeight: 700,
                  color: "white",
                  fontFamily: "Quicksand, sans-serif",
                  cursor: loading ? "not-allowed" : "pointer",
                  marginTop: "4px",
                }}
              >
                {loading ? "Guardando..." : "Guardar contraseña 🔑"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
